import { apiCall, NEW_BE_API } from '../../utils/APIFunctions';

export function getApplications() {
  return apiCall(`${NEW_BE_API}/api/n1/admicom/applications`, "GET");
}

export function getTenants() {
  return apiCall(`${NEW_BE_API}/api/n1/admicom/tenant`, "GET");
}

export function changeTenant(tenantId) {
  return apiCall(`${NEW_BE_API}/api/n1/admicom/tenant`, "POST", JSON.stringify({ tenantId }));
}